import * as actions from "./actionTypes";
import * as config from "config";


export function selectGroup(payload) {
    return {
        type: actions.SELECT_GROUP,
        payload,
    }
}

export function downloadUserGroups(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetAllGroups,
            method: "get",
            data: { ...params },
            onStart: actions.DOWNLOAD_GROUPS_START,
            onSuccess: actions.DOWNLOAD_GROUPS_DONE,
            onError: actions.DOWNLOAD_GROUPS_FAILED,
        },
    }
}

export function getAllGroups(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            // url: config.apiGetAllGroups,
            url: config.apiPayGroup,
            method: "get",
            data: {params},
            onStart: actions.GET_ALL_GROUPS_START,
            onSuccess: actions.GET_ALL_GROUPS,
            onError: actions.GET_ALL_GROUPS_FAILED,
        },
    }
}

export function getGroupsB2b() {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiPayGroup,
            // url: config.apiGetGroupsB2b,
            method: "get",
            // data: params,
            onStart: actions.GET_GROUPS_B2B_START,
            onSuccess: actions.GET_GROUPS_B2B,
            onError: actions.GET_GROUPS_B2B_FAILED,
        },
    }
}

export function getAllGroupEmployees(groupId, params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetAllGroupEmployees + groupId + "/assigned-employees",
            method: "get",
            data: params,
            onStart: actions.GET_ALL_GROUP_EMPLOYEES_START,
            onSuccess: actions.GET_ALL_GROUP_EMPLOYEES,
            onError: actions.GET_ALL_GROUP_EMPLOYEES_FAILED,
        },
    }
}

export function createGroup(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiCreateGroup,
            method: "post",
            data: {
                name: params.groupName,
                limit: params.withdrawalPercent,
                autoWithdrawals: params.autoWithdrawals,
                colorCode: params.colorCode,
            },
            onStart: actions.CREATE_GROUP_START,
            onSuccess: actions.CREATE_GROUP,
            onError: actions.CREATE_GROUP_FAILED,
        },
    }
}

export function createGroupB2b(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiCreateGroupB2b,
            method: "post",
            data: params,
            // data: {
            //     name: params.groupName,
            //     employees: params.employeesIds,
            // },
            onStart: actions.CREATE_GROUP_B2B_START,
            onSuccess: actions.CREATE_GROUP_B2B,
            onError: actions.CREATE_GROUP_B2B_FAILED,
        },
    }
}

export function assignEmployeeToGroup(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiAssignEmployeeToGroup,
            method: "post",
            data: params,
            onStart: actions.ASSIGN_EMPLOYEE_TO_GROUP_START,
            onSuccess: actions.ASSIGN_EMPLOYEE_TO_GROUP,
            onError: actions.ASSIGN_EMPLOYEE_TO_GROUP_FAILED,
        },
    }
}

export function assignSelectionToGroupStart() {
    return {
        type: actions.ASSIGN_SELECTION_TO_GROUP_START,
        payload: {},
    }
}

export function assignSelectionToGroup(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiAssignEmployeeToGroup,
            method: "post",
            data: params,
            onSuccess: actions.ASSIGN_SELECTION_TO_GROUP_SUCCESS,
            onError: actions.ASSIGN_SELECTION_TO_GROUP_FAILED,
        },
    }
}

export function assignSelectionToGroupReset() {
    return {
        type: actions.ASSIGN_SELECTION_TO_GROUP_RESET,
        payload: {},
    }
}

export function editGroup(params, groupId) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiUpdateGroup + groupId,
            method: "put",
            data: params,
            onStart: actions.UPDATE_GROUP_START,
            onSuccess: actions.UPDATE_GROUP,
            onError: actions.UPDATE_GROUP_FAILED,
        },
    }
}

export function updateGroupB2b(params, groupId) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiUpdateGroupB2b + groupId,
            method: "patch",
            data: params,
            onStart: actions.UPDATE_GROUP_B2B_START,
            onSuccess: actions.UPDATE_GROUP_B2B,
            onError: actions.UPDATE_GROUP_B2B_FAILED,
        },
    }
}

export function addEmployeesFromGroupB2b(params, groupId) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiAddEmployeesFromGroupB2b + groupId,
            method: "patch",
            data: params,
            onStart: actions.ADD_EMPLOYEES_FROM_GROUP_B2B_START,
            onSuccess: actions.ADD_EMPLOYEES_FROM_GROUP_B2B,
            onError: actions.ADD_EMPLOYEES_FROM_GROUP_B2B_FAILED,
        },
    }
}

export function removeEmployeesFromGroupB2b(params, groupId) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiRemoveEmployeesFromGroupB2b + groupId,
            method: "patch",
            data: params,
            onStart: actions.REMOVE_EMPLOYEES_FROM_GROUP_B2B_START,
            onSuccess: actions.REMOVE_EMPLOYEES_FROM_GROUP_B2B,
            onError: actions.REMOVE_EMPLOYEES_FROM_GROUP_B2B_FAILED,
        },
    }
}

export function deleteGroup(groupId) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiDeleteGroup + groupId,
            method: "delete",
            data: {},
            onStart: actions.DELETE_GROUP_START,
            onSuccess: actions.DELETE_GROUP,
            onError: actions.DELETE_GROUP_FAILED,
        },
    }
}

export function deleteGroupB2b(groupId) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiDeleteGroupB2b + groupId,
            method: "delete",
            data: null,
            onStart: actions.DELETE_GROUP_START,
            onSuccess: actions.DELETE_GROUP,
            onError: actions.DELETE_GROUP_FAILED,
        },
    }
}

/*
export function editPolicyInfo(params, silent = false) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiUpdatePolicyInfo,
            method: "post",
            data: params,
            onStart: actions.UPDATE_POLICY_INFO_START,
            onSuccess: (silent === 'silent' ? actions.UPDATE_POLICY_INFO_SILENT : actions.UPDATE_POLICY_INFO),
            onError: actions.UPDATE_POLICY_INFO_FAILED,
        },
    }
}
*/

export function resetReloadPage() {
    return {
        type: actions.RELOAD_PAGE_RESET,
        payload: {},
    }
}
